(function () {
    'use strict';

    angular
        .module('franchiser.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, PATHS_FRANCHISER, SYSTEM_MODULES) {
        $stateProvider
            // UNITS
            .state('app.franchiser-units', {
                title: 'Todas as Lojas',
                url: '/franchiser/units',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-list.html`,
                controller: 'UnitListFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })
            .state('app.franchiser-units-new', {
                title: 'Nova Loja',
                url: '/franchiser/units/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-form.html`,
                controller: 'UnitFormFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })
            .state('app.franchiser-units-edit', {
                title: 'Editar Loja',
                url: '/franchiser/units/{unitId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-form.html`,
                controller: 'UnitFormFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })
            .state('app.franchiser-units-reopen', {
                title: 'Nova Loja',
                url: '/franchiser/units/reopen',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-reopen.html`,
                controller: 'UnitReopenFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })

            // UNITS FRANCHISEES HISTORY
            .state('app.franchiser-units-franchisee', {
                title: 'Histórico de Franqueados',
                url: '/franchiser/units/franchisees-history',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-franchisee-history-list.html`,
                controller: 'UnitFranchiseeHistoryListFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })
            .state('app.franchiser-units-franchisee-new', {
                title: 'Novo Franqueado',
                url: '/franchiser/units/franchisees-history/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-franchisee-history-form.html`,
                controller: 'UnitFranchiseeHistoryFormFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })
            .state('app.franchiser-units-franchisee-edit', {
                title: 'Editar Franqueado',
                url: '/franchiser/units/franchisees-history/{franchiseeId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/units/unit-franchisee-history-form.html`,
                controller: 'UnitFranchiseeHistoryFormFranchiserController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_UNIT,
                isRestricted: true
            })

            // APPLICATIONS
            .state('app.franchiser-applications-list', {
                title: 'Aplicações',
                url: '/franchiser/applications',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-list.html`,
                controller: 'ApplicationsFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
                isRestricted: true
            })
            .state('app.franchiser-applications-new', {
                title: 'Aplicações',
                url: '/franchiser/applications/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-form.html`,
                controller: 'ApplicationsFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
                isRestricted: true
            })
            .state('app.franchiser-applications-edit', {
                title: 'Aplicações',
                url: '/franchiser/applications/{applicationId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/applications/application-form.html`,
                controller: 'ApplicationsFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_APPLICATION,
                isRestricted: true
            })

            // PEOPLE
            .state('app.franchiser-people-list', {
                title: 'Buscar Pessoas',
                url: '/franchiser/people',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-list.html`,
                controller: 'PeopleFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
                isRestricted: true
            })
            .state('app.franchiser-people-associate', {
                title: 'Associar Pessoa',
                url: '/franchiser/people/associate',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-associate.html`,
                controller: 'PeopleFranchiserAssociateController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
                isRestricted: true
            })
            .state('app.franchiser-people-associate-franchisee', {
                title: 'Associar Franqueado',
                url: '/franchiser/people/associate/franchisee/{unitId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-associate.html`,
                controller: 'PeopleFranchiserAssociateController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
                isRestricted: true
            })
            .state('app.franchiser-people-edit', {
                title: 'Visualizar Pessoa',
                url: '/franchiser/people/{personId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/people/people-form.html`,
                controller: 'PeopleFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PEOPLE,
                isRestricted: true
            })

            // ECONOMIC GROUPS
            .state('app.franchiser-economic-groups-list', {
                title: 'Grupos de Lojas',
                url: '/franchiser/economic-groups',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/economic-groups/economic-group-list.html`,
                controller: 'EconomicGroupFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ECONOMIC_GROUP,
                isRestricted: true
            })
            .state('app.franchiser-economic-groups-new', {
                title: 'Novo Grupo de Loja',
                url: '/franchiser/economic-groups/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/economic-groups/economic-group-form.html`,
                controller: 'EconomicGroupFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ECONOMIC_GROUP,
                isRestricted: true
            })
            .state('app.franchiser-economic-groups-edit', {
                title: 'Visualizar Grupo de Loja',
                url: '/franchiser/economic-groups/{groupId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/economic-groups/economic-group-form.html`,
                controller: 'EconomicGroupFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ECONOMIC_GROUP,
                isRestricted: true
            })
            .state('app.franchiser-economic-groups-update', {
                title: 'Atualizar Grupos de Loja',
                url: '/franchiser/economic-groups/update-cluster',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/economic-groups/economic-group-update-cluster.html`,
                controller: 'EconomicGroupFranchiserUpdateClusterController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ECONOMIC_GROUP,
                isRestricted: true
            })

            // ACCESS LEVELS
            .state('app.franchiser-access-levels-list', {
                title: 'Níveis de Acesso',
                url: '/franchiser/access-levels',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/access-levels/access-level-list.html`,
                controller: 'AccessLevelFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ACCESS_LEVEL,
                isRestricted: true
            })
            .state('app.franchiser-access-levels-edit', {
                title: 'Visualizar Nível de Acesso',
                url: '/franchiser/access-levels/{accessLevelId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/access-levels/access-level-form.html`,
                controller: 'AccessLevelFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_ACCESS_LEVEL,
                isRestricted: true
            })

            // CLUSTERS
            .state('app.franchiser-clusters-list', {
                title: 'Clusters',
                url: '/franchiser/clusters',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-list.html`,
                controller: 'ClusterFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
                isRestricted: true
            })
            .state('app.franchiser-clusters-new', {
                title: 'Novo Cluster',
                url: '/franchiser/clusters/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-form.html`,
                controller: 'ClusterFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
                isRestricted: true
            })
            .state('app.franchiser-clusters-edit', {
                title: 'Visualizar Cluster',
                url: '/franchiser/clusters/{clusterId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/clusters/cluster-form.html`,
                controller: 'ClusterFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER,
                isRestricted: true
            })

            // CLUSTER PERFORMANCE
            .state('app.franchiser-cluster-performance-list', {
                title: 'Clusters',
                url: '/franchiser/cluster-performance',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/cluster-performance/cluster-performance-list.html`,
                controller: 'ClusterPerformanceFranchiserListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER_PERFORMANCE,
                isRestricted: true
            })
            .state('app.franchiser-cluster-performance-new', {
                title: 'Novo Cluster Performance',
                url: '/franchiser/cluster-performance/new',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/cluster-performance/cluster-performance-form.html`,
                controller: 'ClusterPerformanceFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER_PERFORMANCE,
                isRestricted: true
            })
            .state('app.franchiser-cluster-performance-edit', {
                title: 'Visualizar Cluster Performance',
                url: '/franchiser/cluster-performance/{clusterPerformanceId:int}',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/cluster-performance/cluster-performance-form.html`,
                controller: 'ClusterPerformanceFranchiserFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_CLUSTER_PERFORMANCE,
                isRestricted: true
            })

            // PAYMENT REMITTANCE
            .state('app.franchiser-payment-remittances', {
                title: 'Remessas de Boletos',
                url: '/franchiser/payment-remittances',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-remittance/payment-remittances-list.html`,
                controller: 'PaymentRemittancesListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            .state('app.franchiser-payment-remittance-slips', {
                title: 'Boletos da Remessa',
                url: '/franchiser/payment-remittances/{paymentRemittanceId:int}/slips',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-remittance/payment-remittances-slips-list.html`,
                controller: 'PaymentRemittancesSlipsListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            .state('app.franchiser-payment-remittance-import', {
                title: 'Importação de Remessa',
                url: '/franchiser/payment-remittances/import',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-remittance/payment-remittances-import.html`,
                controller: 'PaymentImportSlipsFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            // PAYMENT CONFIRMATION
            .state('app.franchiser-payment-confirmation', {
                title: 'Remessas de Pagamento',
                url: '/franchiser/payment-confirmation',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-confirmation/payment-slip-confirmation-list.html`,
                controller: 'PaymentConfirmationListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            .state('app.franchiser-payment-confirmation-slips', {
                title: 'Boletos da Remessa de Confirmação',
                url: '/franchiser/payment-confirmation/{paymentConfirmationRemittanceId:int}/slips',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-confirmation/payment-confirmation-slips-list.html`,
                controller: 'PaymentConfirmationSlipsListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            .state('app.franchiser-payment-confirmation-import', {
                title: 'Importação de Remessa de Pagamento',
                url: '/franchiser/payment-confirmation/import',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip-confirmation/payment-confirmation-import.html`,
                controller: 'PaymentImportSlipConfirmationsFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })

            // PAYMENT SLIP
            .state('app.payment-slip-search', {
                title: 'Buscar Boleto',
                url: '/franchiser/payment-slip-search',
                templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/components/payment-slip/payment-slip-search.html`,
                controller: 'PaymentSlipSearchController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISER_PAYMENT_SLIP,
                isRestricted: true
            })
    }
}());